import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { BaseService } from '../../core/base.service';
import {
  AtualizarParceriaComercialRequest,
  CancelarParceriaComercialRequest,
  CancelarParceriaComercialResponse,
  ConviteParceriaResponse,
  CriarParceriaComercialRequest,
  EmitirConviteParceriaRequest,
  FinalizarCadastroParceriaRequest,
  FinalizarCadastroParceriaResponse,
  ParceriaComercialResponse,
  StatusConviteParceriaEnum,
  ValidarTokenConviteResponse,
} from 'app/shared/models/ei-models';

@Injectable({ providedIn: 'root' })
export class ParceriaComercialService extends BaseService {
  private endpoint = environment.urlEdducaImobApi.concat('api/ParceriaComercial/');
  private cadastroEndpoint = environment.urlEdducaImobApi.concat('api/CadastroParceria/');

  constructor(private http: HttpClient) {
    super();
  }

  listar(somenteAtivas = false): Observable<ParceriaComercialResponse[]> {
    const params = new HttpParams().set('somenteAtivas', String(somenteAtivas));
    return this.http.get<ParceriaComercialResponse[]>(this.endpoint, {
      headers: this.getHeader(true),
      params,
    });
  }

  obterPorId(id: number): Observable<ParceriaComercialResponse> {
    return this.http.get<ParceriaComercialResponse>(this.endpoint.concat(String(id)), {
      headers: this.getHeader(true),
    });
  }

  criar(request: CriarParceriaComercialRequest): Observable<ParceriaComercialResponse> {
    return this.http.post<ParceriaComercialResponse>(this.endpoint, request, {
      headers: this.getHeader(true),
    });
  }

  atualizar(id: number, request: AtualizarParceriaComercialRequest): Observable<ParceriaComercialResponse> {
    return this.http.put<ParceriaComercialResponse>(this.endpoint.concat(String(id)), request, {
      headers: this.getHeader(true),
    });
  }

  cancelar(id: number, request: CancelarParceriaComercialRequest): Observable<CancelarParceriaComercialResponse> {
    return this.http.post<CancelarParceriaComercialResponse>(
      this.endpoint.concat(`${id}/cancelar`),
      request,
      { headers: this.getHeader(true) },
    );
  }

  listarConvites(parceriaId: number, status?: StatusConviteParceriaEnum): Observable<ConviteParceriaResponse[]> {
    let params = new HttpParams();
    if (status !== undefined && status !== null) {
      params = params.set('status', String(status));
    }
    return this.http.get<ConviteParceriaResponse[]>(
      this.endpoint.concat(`${parceriaId}/convites`),
      { headers: this.getHeader(true), params },
    );
  }

  emitirConvite(request: EmitirConviteParceriaRequest): Observable<ConviteParceriaResponse> {
    return this.http.post<ConviteParceriaResponse>(
      this.endpoint.concat('convites'),
      request,
      { headers: this.getHeader(true) },
    );
  }

  revogarConvite(conviteId: number): Observable<void> {
    return this.http.post<void>(
      this.endpoint.concat(`convites/${conviteId}/revogar`),
      {},
      { headers: this.getHeader(true) },
    );
  }

  // Endpoints públicos (sem token de auth)
  validarTokenConvite(token: string): Observable<ValidarTokenConviteResponse> {
    return this.http.get<ValidarTokenConviteResponse>(this.cadastroEndpoint.concat(`validar-token/${token}`));
  }

  finalizarCadastro(request: FinalizarCadastroParceriaRequest): Observable<FinalizarCadastroParceriaResponse> {
    return this.http.post<FinalizarCadastroParceriaResponse>(
      this.cadastroEndpoint.concat('finalizar'),
      request,
    );
  }
}
